import React, { Component } from "react";

class Cars extends Component{
    render(){
        return(
            <div>
                <h1>Cars</h1>
            </div>
        );
    }
}
export default Cars